import { createContext, ReactNode, useContext } from "react";

import { useFilterPackageAccommodation } from "./filter-package-accommodation.hook";

const FilterPackageAccommodationContext = createContext(
  {} as ReturnType<typeof useFilterPackageAccommodation>
);
export function useFilterPackageAccommodationContext() {
  return useContext(FilterPackageAccommodationContext);
}

interface FilterPackageAccommodationProviderProps {
  children: ReactNode;
}
export function FilterPackageAccommodationProvider({
  children,
}: FilterPackageAccommodationProviderProps) {
  return (
    <FilterPackageAccommodationContext.Provider value={useFilterPackageAccommodation()}>
      {children}
    </FilterPackageAccommodationContext.Provider>
  );
}